const SEEN_KEY = 'gisekibris.panel.notif.seenFingerprint';

/** Mevcut bildirim kalemlerinden tekil imza */
export const buildNotifFingerprint = ({ eventItems = [], applicationItems = [] } = {}) => {
  const ids = [
    ...eventItems.map((e) => `ev:${e.id}`),
    ...applicationItems.map((a) => `app:${a.id}`),
  ].sort();
  return ids.join('|');
};

export const getSeenNotifFingerprint = () => {
  try {
    return localStorage.getItem(SEEN_KEY) || '';
  } catch {
    return '';
  }
};

export const setSeenNotifFingerprint = (fingerprint) => {
  try {
    localStorage.setItem(SEEN_KEY, fingerprint || '');
  } catch {
    // ignore
  }
};

/** Okundu yapildiktan sonra ayni liste icin rozet gizlensin */
export const countUnreadNotifs = (total, fingerprint) => {
  if (!total) return 0;
  const seen = getSeenNotifFingerprint();
  if (seen && seen === fingerprint) return 0;
  return total;
};
